<template>
    <div id="matches">
        <div id="app-layout-right-column__content__title">
            <span>Matches</span>
        </div>
        <MatchFilters />
        <div class="scrollable-con">
            <MatchTemplate v-for="match in filteredMatches"
                           :key="match.placeholder ? match.id + '-placeholder' : match.id"
                           :match="match" />
        </div>
    </div>
</template>

<script>
import MatchFilters from "@/components/app/matches/MatchFilters.vue";
import MatchTemplate from "@/components/app/matches/MatchTemplate.vue";
import { mapGetters, mapState } from "vuex";

export default {
    components: {MatchFilters, MatchTemplate},
    computed: {
        ...mapState("UI", ["matches"]),
        ...mapState("Projects", ["image"]),
        ...mapGetters('UI', ['filteredMatches']),

    }
}
</script>

<style lang="scss" scoped>
#matches {
    display: grid;
    align-content: start;

    > span {
        width: 100%;
        display: block;
        font-size: 1.25rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 10px;

        &:first-of-type {
            margin-top: 10px;
        }

        &:not(:first-of-type) {
            margin-top: 30px;
            margin-bottom: 20px;
            border-top: 1px solid var(--primary);
            padding-top: 20px;
        }
    }

    .bin-name {
        color: var(--color-title-light);
    }
}
</style>